import {
  Autocomplete,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  Typography,
} from '@mui/material';
import { CustomButton, CustomTextField, CustomSelect } from '../../../../../common/components';

/**
 * Diálogo para agregar/editar suscriptores del proyecto
 * Solo campos necesarios: subscriber, role, assigned_date
 */
const ProjectSubscriberDialog = ({
  subscriberDialogOpen,
  editModeSubscriber,
  selectedSubscriber,
  matchingSubscribers,
  handleCloseSubscriberDialog,
  handleInputChangeSubscriber,
  handleInputChangeDNISubscriber,
  handleSubscriberSelection,
  handleSaveSubscriber,
}) => {
  const roleOptions = [
    { value: 'owner', label: 'Propietario' },
    { value: 'collaborator', label: 'Colaborador' },
    { value: 'viewer', label: 'Observador' },
  ];

  return (
    <Dialog open={subscriberDialogOpen} onClose={handleCloseSubscriberDialog} maxWidth="sm" fullWidth>
      <Box sx={{ p: 2, borderBottom: '2px solid #5e894f', backgroundColor: '#f2f2f2' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#5e894f', textAlign: 'center' }}>
          {editModeSubscriber ? 'EDITAR SUSCRIPTOR DEL PROYECTO' : 'AGREGAR SUSCRIPTOR AL PROYECTO'}
        </Typography>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {/* Campo DNI con Autocomplete */}
          {!editModeSubscriber ? (
            <Autocomplete
              options={matchingSubscribers}
              getOptionLabel={(subscriber) =>
                `(${subscriber.dni}) ${subscriber.last_name}, ${subscriber.first_name}`
              }
              renderInput={(params) => (
                <CustomTextField
                  {...params}
                  margin="dense"
                  name="dni"
                  label="DNI del Suscriptor"
                  fullWidth
                  onChange={handleInputChangeDNISubscriber}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'new-password',
                  }}
                />
              )}
              onChange={(event, value) => handleSubscriberSelection(value)}
            />
          ) : (
            <CustomTextField
              disabled
              margin="dense"
              name="dni"
              label="DNI"
              fullWidth
              value={selectedSubscriber.subscriber?.dni || ''}
            />
          )}

          {/* Información del suscriptor seleccionado */}
          {selectedSubscriber?.subscriber && (
            <CustomTextField
              margin="dense"
              name="name"
              label="Nombre Completo"
              fullWidth
              disabled
              value={`${selectedSubscriber.subscriber.first_name} ${selectedSubscriber.subscriber.last_name}`}
            />
          )}

          {/* Rol en el proyecto */}
          <CustomSelect
            label="Rol en el Proyecto"
            name="role"
            value={selectedSubscriber?.role || 'owner'}
            onChange={handleInputChangeSubscriber}
            fullWidth
            required
          >
            {roleOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </CustomSelect>

          {/* Fecha de asignación */}
          <CustomTextField
            label="Fecha de Asignación"
            name="assigned_date"
            type="date"
            value={selectedSubscriber?.assigned_date || new Date().toISOString().split('T')[0]}
            onChange={handleInputChangeSubscriber}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: '1px solid #e0e0e0' }}>
        <CustomButton onClick={handleCloseSubscriberDialog} variant="text">
          Cancelar
        </CustomButton>
        <CustomButton 
          onClick={handleSaveSubscriber} 
          variant="contained"
          disabled={!selectedSubscriber?.subscriber}
        >
          Guardar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectSubscriberDialog;
